import * as React from 'react'

import Grid from '@material-ui/core/Grid'
import Grow from '@material-ui/core/Grow'

import { Program }                   from '../../api'
import { isPresentInAnyOf, memoize } from '../../utils'
import loadable                      from '../hocs/loadable'
import ProgramCard                   from './ProgramCard'

interface ProgramListProps {
  programs: Program []
  onProgramClick: (program: Program) => void
  filterValue: string
}

class ProgramList extends React.Component<ProgramListProps> {
  private memoizedOnClick = memoize(
    (id, program) => {
      return () => {
        this.props.onProgramClick(program)
      }
    }
  )

  public render () {
    const { programs } = this.props

    return (
      <Grid container spacing={16} alignItems={'stretch'}>
        {programs && programs.map(this.generateProgramListItem)}
      </Grid>
    )
  }

  private generateProgramListItem = (program: Program) => {
    const { filterValue } = this.props
    const { company, details } = program

    const shouldDisplay =
      isPresentInAnyOf(
        filterValue,
        [
          company.name,
          details.name,
        ]
      )

    return (
      <Grow
        key={program.id}
        mountOnEnter
        unmountOnExit
        in={shouldDisplay}
      >
        <Grid
          item
          xs={12}
          md={6}
          lg={4}
        >
          <ProgramCard
            onClick={this.memoizedOnClick(program.id, program)}
            {...program}
          />
        </Grid>
      </Grow>
    )
  }
}

export default loadable(ProgramList)



// WEBPACK FOOTER //
// ./src/components/molecules/ProgramList.tsx